import React from "react";
import { Box, Stack } from "@mui/material";

export const BRAND_COLORS = {
  primary: "#0E7A6E",
  dark: "#0B5F56",
  light: "#E6F5F2",
  accent: "#00BFA5",
  text_dark: "#12181A",
  text_light: "#66766F",
  bg_light: "#F5F8F7",
  border_color: "#E6ECEA",
};

const WrapperComponent = ({
  actions = [],
  children,
  title = "Component Title",
  subTitle = "Component subtitle",
  icon = null,
  sx = {},
}) => {
  return (
    <Box
      sx={{
        // background: BRAND_COLORS.bg_light,
        minHeight: "100vh",
        py: 4,
        ...sx,
      }}
    >
      {/* Slim page header — replaces the previous large gradient hero banner.
          Same props (title/subTitle/icon) are still consumed, just laid out
          more compactly with no decorative background shapes. */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 2,
          pb: 2.5,
          mb: 3,
          borderBottom: `1px solid ${BRAND_COLORS.border_color}`,
        }}
      >
        {/* {icon && (
          <Box
            sx={{
              width: 44,
              height: 44,
              borderRadius: "10px",
              background: `linear-gradient(135deg, ${BRAND_COLORS.primary} 0%, ${BRAND_COLORS.dark} 100%)`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "white",
              flexShrink: 0,
              "& svg": { fontSize: 22 },
            }}
          >
            {icon}
          </Box>
        )} */}

        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Box
            component="h2"
            sx={{
              fontSize: { xs: 20, md: 24 },
              fontWeight: 700,
              letterSpacing: "-0.015em",
              m: 0,
              color: BRAND_COLORS.text_dark,
            }}
          >
            {title}
          </Box>
          <Box
            component="p"
            sx={{
              fontSize: 13.5,
              color: BRAND_COLORS.text_light,
              fontWeight: 400,
              m: 0,
              mt: 0.25,
            }}
          >
            {subTitle}
          </Box>
        </Box>
      </Box>

      <Box sx={{ p: 0, position: "relative", zIndex: 2 }}>
        {children}

        {actions.length > 0 && (
          <Stack
            direction="row"
            gap={{ xs: 2, sm: 3 }}
            justifyContent={{ xs: "space-between", sm: "flex-end" }}
            alignItems="center"
            mt={2}
            sx={{
              flexWrap: "wrap",
              pt: 3,
            }}
          >
            {actions.map((action, idx) => (
              <Box key={idx}>{action}</Box>
            ))}
          </Stack>
        )}
      </Box>
    </Box>
  );
};

export default WrapperComponent;